import { styled } from '@mui/system';
import { theme } from 'oems/theme';
import { Stack as StackMUI } from '@mui/material';

export const Stack = styled('div')`
  background-color: ${(props) => theme.palette.pricing[props.type]};
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: top;
  padding: 24px 24px 32px;
  border: ${`1px solid ${theme.palette.text.dark}`};
  border-radius: 12px;
  width: 250px;
  max-height: 316px;
  min-height: 316px;
`;

export const Description = styled('h4')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 6700;
  font-size: 14px;
  line-height: 17.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 16px;
  color: ${theme.palette.text.dark};
`;

export const EmptyContainer = styled('div')`
  height: 40px;
`;

export const BottomContainer = styled(StackMUI)`
  margin-top: 20px;
`;
